// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2v7ua","clinicsSelect":"styles_clinicsSelect__3ohAi"};